import { DatePipe } from "@angular/common";
import { CommissionEnum } from "@enums/commission";
import { Table } from "@models/table";
import { ProfileDataModalComponent } from "@pages/shared/reports/commissions-report/profile-data-modal/profile-data-modal.component";
import { formatNumberToLocal } from "src/app/utils/format-number-to-local";

const datePipe = new DatePipe('pt-BR');
const brazilianNumberFormat = new Intl.NumberFormat('pt-BR', {
  style: 'decimal',
  currency: 'BRL',
});

export const FILTER_WITHHELD_COMMISIONS = {
    id: CommissionEnum.WITHHELD_COMMISSIONS,
    description: 'Comissões Retidas por Pendência',
    startDateLabel: 'Data de venda inicial:',
    endDateLabel: 'Data de venda final:',
    filters: [
      {
        description: "Tipo de Consulta:",
        key: "typeQuery",
        options: [
          { key: "0", value: "Todos" },
          { key: "1", value: "Pendencia contrato" }, //executa queries (back) diferentes de acordo com o tipo de consulta selecionada
          { key: "2", value: "Atraso parcela" },
          { key: "3", value: "Cancelamento" },
        ]
      },
      {
        description: "Filtrar por: ",
        key: "filterBy",
        options: [  
          { key: " ", value: "Sem filtro" }, 
          { key: "contract", value: "Contrato" },
        ]
      }
    ],
    buttons: {read: true},
    componentModal: ProfileDataModalComponent
  }


  export const REPORT_WITHELD_COMMISSIONS: Partial<Table<any>> = {
      headers: [
        { key: "contract", value: "Contrato" },
        { key: "group", value: "Grupo" },
        { key: "quota", value: "Cota" },
        { key: "version", value: "Versão" },
        { key: "sellerDocument", value: "CPF Vendedor" },
        { key: "assetValue", value: "Valor do Bem" },
        { key: "saleDate", value: "Data da Venda" },
        // { key: "personName", value: "Cliente" },
        // { key: "email", value: "Email" },
        // { key: "address", value: "Endereço" },
        // { key: "city", value: "Cidade" },
        // { key: "state", value: "UF" },
        // { key: "phone", value: "Telefone" },
        { key: "installment", value: "Parcela Comissão" },
        { key: "comissionPercentual", value: "Comissão (%)" },
        { key: "reversalValue", value: "Estorno" },
        { key: "pendencyType", value: "Tipo Pendência" },
        { key: "pendency", value: "Observação" },
        { key: "totalValue", value: "Valor Total" },
        // { key: "personId", value: "Id Pessoa" },
      ],
      style: {
        table: {
          height: "500px",
        },
        data: [
          {
            key: "saleDate",
            transform: (value) => datePipe.transform(value, "dd/MM/yyyy"),
          },
          {
            key: "assetValue",
            transform: (value) => value ? `R$ ${ formatNumberToLocal(value) }` : "N/A",
          },
          {
            key: "reversalValue",
            transform: (value) => value ? `R$ ${ formatNumberToLocal(value) }` : "N/A",
          },
          {
            key: "totalValue",
            transform: (value) => value ? `R$ ${ formatNumberToLocal(value) }` : "N/A",
          }
        ],
      },
      buttons: {read: true},
      messageWithoutDates: "Nenhum dado encontrado para 'Comissões Retidas por Pendência'",
  }
